<section class="row menus-container">
  <app-search-bar
    placeholder="Search items by name or category"
    (searchChange)="filterMenus($event)"
  ></app-search-bar>
  <div class="col col-12 toolbar-container" *ngIf="enableToolbar">
    <ion-toolbar>
      <ion-title class="page-title p-0">
        <span [innerText]="menus?.length"></span>
        <span
          *ngIf="menuId; else menuHeading"
          translate="SUB_MENUS"
          class="mx-2"
        >
        </span>
        <ng-template #menuHeading
          ><span translate="MENUS" class="mx-2"> </span
        ></ng-template>
      </ion-title>

      <section class="actions" slot="end" *ngIf="!forCustomer">
        
        <ion-button
          fill="outline"
          class="ion-text-capitalize"
          (click)="onNewClick()"
          translate="NEW_MENU"
        >
          <ion-icon slot="start" name="add-outline"></ion-icon>
        </ion-button>
      </section>
    </ion-toolbar>
  </div>

  <ion-card
    *ngFor="let menu of menus; let i = index"
    class="col col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 item-with-borders menu"
    (click)="onMenuClick(menu)"
    button
  >
    <div
      class="thumbnail"
      [style.background-image]="
        menu.menuIconImage ? 'url(' + menu.menuIconImage.url + ')' : ''
      "
    >
      <section class="d-flex indicators" *ngIf="!forCustomer">
        <div class="publish-status" *ngIf="menu.menuStatus">

          <ion-icon
            *ngIf="menu.menuStatus === 'PUBLISHED'"
            title="Published"
            color="success"
            src="assets/icons/published_with_changes_24dp.svg"
            class="d-block"
          ></ion-icon>

          <ion-icon
            *ngIf="menu.menuStatus === 'DRAFT'"
            title="Unpublished"
            color="primary"
            src="assets/icons/unpublished_24dp.svg"
            class="d-block"
          ></ion-icon>

        </div>
      </section>
    </div>

    <ion-card-header>
      <ion-card-title class="mt-2" [innerText]="menu.name"></ion-card-title>
      <ion-card-subtitle class="tags" *ngIf="menu.tags?.length">
        <ion-icon name="pricetags-outline"></ion-icon>
        <span [innerText]="menu.tags?.join(', ')"></span>
      </ion-card-subtitle>
      <ion-card-subtitle>

        <ion-icon name="menu-outline"></ion-icon>

        <span *ngIf="menu.noOfChildItems; else subMenuCount">
          <span
            class="child-count"
            [innerText]="'(' + menu.noOfChildItems + ')'"
          ></span>
          <span class="mx-1">Food Items</span>
        </span>

        <ng-template #subMenuCount>

          <span
            class="child-count"
            [innerText]="'(' + menu.noOfChildMenus + ')'"
          ></span>
          <span class="mx-1"> Sub Menus</span>

        </ng-template>
      </ion-card-subtitle>
      <section class="actions" *ngIf="!forCustomer">

        <ion-button
          color="primary"
          fill="clear"
          title="Edit"
          (click)="onEditClick($event, menu)"
        >
          <ion-icon
            slot="icon-only"
            src="assets/icons/edit_24dp.svg"
          ></ion-icon>
        </ion-button>

        <ion-button
          color="danger"
          fill="clear"
          title="Delete"
          (click)="onDeleteClick($event, menu, i)"
        >
          <ion-icon slot="icon-only" color="danger" name="trash-outline"></ion-icon>
        </ion-button>

      </section>
    </ion-card-header>
    <ion-card-content>
      <div class="description" [innerText]="menu?.description"></div>
    </ion-card-content>
  </ion-card>

  <ng-container *ngIf="!menus?.length">
    <ion-list class="no-data-section">
      <ion-item lines="none" class="ion-text-center">
        <ion-label>No Items to Display!</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
</section>
